import {
  FETCH_ADVERTISEMENTS,
  OPEN_ADVT_MODAL,
  ADVT_BANNERS,
  LOAD_EDIT_ADVT_DATA,
} from "ActionsAdvertisement";

export function advertisementsList(state = [], action) {
  switch (action.type) {
    case FETCH_ADVERTISEMENTS:
      return action.payload;
    default:
      return state;
  }
}

export function advtAddModal(state = {}, action) {
  switch (action.type) {
    case OPEN_ADVT_MODAL:
      return action.payload;
    default:
      return state;
  }
}

export function advtBannerOptions(state = {}, action) {
  switch (action.type) {
    case ADVT_BANNERS:
      return action.payload;
    default:
      return state;
  }
}

export function advtEditData(state = {}, action) {
  switch (action.type) {
    case LOAD_EDIT_ADVT_DATA:
      return action.payload;
    default:
      return state;
  }
}
